import { SelectionMode } from "../../../../base/SelectionMode";
import { AbstractStandardTableToolsPanel } from "./AbstractStandardTableToolsPanel";
import { AdvancedSearchButton } from "./buttons/AdvancedSearchButton";
import { DefaultDetailButton } from "./buttons/DefaultDetailButton";
import { DeleteButton } from "./buttons/DeleteButton";
import { DetailDropdownButton } from "./buttons/DetailDropdownButton";
import { ShareButton } from "./buttons/ShareButton";

enum InnerIds {
    BUTTON_ADVANCED_SEARCH = "buttonAdvancedSearch",
    BUTTON_DELETE = "buttonDelete",
    BUTTON_SHARE = "buttonShare",
    BUTTON_DEFAULT_DETAIL = "buttonDefaultDetail",
    BUTTON_DETAIL_DROPDOWN = "buttonDetailDropdown"
}

export class StandardLeftToolsPanel extends AbstractStandardTableToolsPanel {
    buttonAdvancedSearch: AdvancedSearchButton;
    private buttonDelete: DeleteButton;
    private buttonShare: ShareButton;
    private buttonDefaultDetail: DefaultDetailButton;
    private buttonDetailDropdown: DetailDropdownButton;

    override syncInnerComponentIds() {
        this.setInnerComponentId(this.buttonAdvancedSearch.get(), InnerIds.BUTTON_ADVANCED_SEARCH);
        this.setInnerComponentId(this.buttonDelete.get(), InnerIds.BUTTON_DELETE);
        this.setInnerComponentId(this.buttonShare.get(), InnerIds.BUTTON_SHARE);
        this.setInnerComponentId(this.buttonDefaultDetail.get(), InnerIds.BUTTON_DEFAULT_DETAIL);
        this.setInnerComponentId(this.buttonDetailDropdown.get(), InnerIds.BUTTON_DETAIL_DROPDOWN);
    }

    override createComponents() {
        this.createAdvancedSearchButton();
        this.createDeleteButton();
        this.createShareButton();
        this.createDefaultDetailButton();
        this.createDetailDropdownButton();
    }

    private createAdvancedSearchButton() {
        this.buttonAdvancedSearch = new AdvancedSearchButton(this.table, this.commonButtonProps);
        this.buttonAdvancedSearch.get().id = this.createInnerComponentId(InnerIds.BUTTON_ADVANCED_SEARCH);
    }

    private createDeleteButton() {
        this.buttonDelete = new DeleteButton(this.table, this.commonButtonProps);
        this.buttonDelete.get().id = this.createInnerComponentId(InnerIds.BUTTON_DELETE);
    }

    private createShareButton() {
        this.buttonShare = new ShareButton(this.table, this.commonButtonProps);
        this.buttonShare.get().id = this.createInnerComponentId(InnerIds.BUTTON_SHARE);
    }

    private createDefaultDetailButton() {
        this.buttonDefaultDetail = new DefaultDetailButton(this.table, this.commonButtonProps);
        this.buttonDefaultDetail.get().id = this.createInnerComponentId(InnerIds.BUTTON_DEFAULT_DETAIL);
    }

    private createDetailDropdownButton() {
        this.buttonDetailDropdown = new DetailDropdownButton(this.table, this.commonButtonProps);
        this.buttonDetailDropdown.get().id = this.createInnerComponentId(InnerIds.BUTTON_DETAIL_DROPDOWN);
    }

    override sync() {
        this.removeAll();
        this.addTool(this.table.crudManager.allowAdvancedSearch, this.buttonAdvancedSearch?.get());
        this.addTool(this.table.selectionMode !== SelectionMode.NONE && this.table.allowDelete,
            this.buttonDelete?.get());
        this.addTool(this.table.allowShare, this.buttonShare?.get());
        const allowDetail = this.table.crudManager.allowDetail;
        this.addTool(allowDetail, this.buttonDefaultDetail?.get());
        this.addTool(allowDetail, this.buttonDetailDropdown?.get());
    }

    syncDefaultDetailButton() {
        this.buttonDefaultDetail.sync();
    }

    override getPopulatedPaddingLeft(): number {
        return 4;
    }

    override getPopulatedPaddingRight(): number {
        return 4;
    }
}
